import { Select, Stack } from '@mantine/core';
import { useUpdateContact, type Contact } from '@/models/contacts';
import {
  referringAgentOptions,
  useReferringAgents,
} from '@/models/referringAgents';
import { FormSaveBar } from '@/components/FormSaveBar';
import { CollapsibleCard } from '@/components/CollapsibleCard';
import { useCardForm } from '@/lib/useCardForm';

type Values = {
  referringAgentId: number | null;
};

export function ReferralCard({
  contact,
  readOnly,
}: {
  contact: Contact;
  readOnly?: boolean;
}) {
  const update = useUpdateContact();
  const agents = useReferringAgents('', undefined, 200);
  const { form, dirty, saving, handleSubmit } = useCardForm<Values>({
    initialValues: {
      referringAgentId: contact.referringAgentId ?? null,
    },
    enabled: !readOnly,
    save: (dirtyValues) =>
      update.mutateAsync({ id: contact.id, ...dirtyValues }),
    successMessage: 'Referral saved',
  });

  return (
    <CollapsibleCard title="Referral">
      <form onSubmit={handleSubmit}>
        <Stack gap="xs">
          <Select
            label="Referring agent"
            size="xs"
            placeholder="No agent"
            data={referringAgentOptions(
              agents.data?.agents,
              contact.referringAgentId,
              contact.referringAgentName,
            )}
            value={
              form.values.referringAgentId == null
                ? null
                : String(form.values.referringAgentId)
            }
            onChange={(v) =>
              form.setFieldValue('referringAgentId', v ? Number(v) : null)
            }
            searchable
            clearable
            disabled={readOnly}
          />
          {dirty && !readOnly && (
            <FormSaveBar saving={saving} onDiscard={form.reset} />
          )}
        </Stack>
      </form>
    </CollapsibleCard>
  );
}
